import React from 'react'
import FloatCard from './FloatCard'

// Satu blok form (Informasi, Konten, Gambar, ...) sebagai kartu dengan judul
// dan keterangan di kepalanya, mengikuti kartu di dashboard.
const FormSection = ({ title, description, children }) => {
  return (
    <FloatCard>
      <div className="px-5 py-4 border-b border-line">
        <div className="font-bold text-base text-ink">{title}</div>
        {description && (
          <div className="text-[13px] text-muted mt-0.5">{description}</div>
        )}
      </div>
      <div className="px-5 py-5 flex flex-col gap-4">{children}</div>
    </FloatCard>
  )
}

export default FormSection
